module.exports = __webpack_public_path__ + "static/media/ic_next.8035b29a.svg";